<script lang="ts">
  export let id: string;
  export let label = 'Wird geladen';
</script>

<div class="loading-spinner-wrapper">
  <div class="loading-spinner" {id} aria-label={label} role="progressbar" />
</div>

<style module>
  .loading-spinner {
    --max-spinner-size: var(--loading-spinner-max-size, 140px);
    box-sizing: border-box;
    font-size: 3em;
    font-size: clamp(calc(0.5 * var(--max-spinner-size)), 12cqw + 1em, var(--max-spinner-size));
    width: 1em;
    height: 1em;
    max-height: 90%;
    aspect-ratio: 1;
    border-radius: 50%;
    border: 6px solid;
    border-right-color: transparent;
    color: #ffffff; /* Fallback for older browsers */
    color: var(--primary-color);
    animation: --rotate linear 1.2s infinite;
  }

  @media (prefers-reduced-motion: reduce) {
    .loading-spinner {
      animation: none;
    }
  }

  @keyframes --rotate {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  @media (prefers-contrast: more) {
    .loading-spinner-wrapper {
      padding: 0.5rem;
      background: var(--controls-contrast-background);
    }
  }

  @media (prefers-contrast: more) and (prefers-reduced-transparency: reduce) {
    .loading-spinner-wrapper {
      background: var(--controls-no-transparency-background);
    }
  }
</style>
